export const isAllowedPayLaterLodging = (
  allowedLodgingIds: string[] | undefined,
  lodgingId?: string
): boolean => {
  if (!allowedLodgingIds || allowedLodgingIds.length === 0) {
    return true;
  }

  if (allowedLodgingIds.includes("*")) {
    return true;
  }

  return !!lodgingId && allowedLodgingIds.includes(lodgingId);
};
